import type { HomepageSettings } from './types';

export const DEFAULT_HOMEPAGE_SETTINGS: HomepageSettings = {
  id: 1,
  heroTitle: 'Học AI theo việc bạn đang làm, nhẹ nhàng từng bước.',
  heroDescription:
    'Khóa học và skill được xây từ quy trình thực tế, để bạn hiểu nhanh, làm được ngay và chủ động học theo nhịp của mình.',
  primaryCtaLabel: 'Xem khóa học',
  primaryCtaHref: '#khoa-hoc',
  secondaryCtaLabel: 'Nhập code kích hoạt',
  secondaryCtaHref: '/kich-hoat',
  heroArtLabel: 'Học · Làm · Tự động hóa',
  heroMediaType: 'NONE',
  heroMediaUrl: null,
  heroPosterUrl: null,
  coursesHeading: 'Khóa học',
  coursesDescription: 'Từ nền tảng đến ứng dụng sâu vào công việc hằng ngày.',
  skillsHeading: 'Skill tải về',
  skillsDescription: 'Mua một lần, tải lại thoải mái khi có phiên bản cập nhật.',
  workshopsHeading: 'Workshop',
  workshopsDescription: 'Đăng ký trước để giữ chỗ cho những buổi sắp diễn ra.',
  quoteText:
    'Tôi chỉ dạy những gì mình đang dùng hằng ngày. Mỗi bài học là một quy trình bạn áp dụng được ngay trong tuần đó.',
  quoteName: 'Huy',
  quoteRole: 'Người xây dựng khóa học AI ứng dụng',
  quoteImageUrl: null,
  createdAt: '',
  updatedAt: '',
};
